import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js'

// Connects to data-controller="select"
export default class extends Controller {
  static targets = ['element']
  connect() {
    const choices = new Choices(this.elementTarget, {
      classNames: {
        containerOuter: ['choices'],
        containerInner: ['choices__inner', 'dark:!bg-transparent', 'dark:!border-slate-700/40', '!py-1.5', 'font-medium'],
        input: ['choices__input', 'dark:!bg-transparent', 'dark:!border-slate-700/40'],
        inputCloned: ['choices__input--cloned'],
        list: ['choices__list', 'dark:!bg-slate-800', 'dark:!border-slate-700/40'],
        listItems: ['choices__list--multiple'],
        listSingle: ['choices__list--single'],
        listDropdown: ['choices__list--dropdown'],
        item: ['choices__item', 'hover:dark:!bg-slate-800', 'dark:!bg-slate-800'],
        itemSelectable: ['choices__item--selectable'],
        itemDisabled: ['choices__item--disabled'],
        itemChoice: ['choices__item--choice'],
        description: ['choices__description'],
        placeholder: ['choices__placeholder'],
        group: ['choices__group'],
        groupHeading: ['choices__heading'],
        button: ['choices__button'],
        activeState: ['is-active'],
        focusState: ['is-focused'],
        openState: ['is-open'],
        disabledState: ['is-disabled'],
        highlightedState: ['is-highlighted'],
        selectedState: ['is-selected'],
        flippedState: ['is-flipped'],
        loadingState: ['is-loading'],
        notice: ['choices__notice'],
        addChoice: ['choices__item--selectable', 'add-choice'],
        noResults: ['has-no-results'],
        noChoices: ['has-no-choices'],
      },
    })
  }
}
